// ============================================
// Path: /frontend/src/api/upload.api.js
// Purpose: Image upload API endpoints
// ============================================

import apiClient from './client.js';

export const uploadAPI = {
  // Upload image
  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append('image', file);
    
    const response = await apiClient.post('/upload/image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Delete image
  deleteImage: async (filename) => {
    const response = await apiClient.delete(`/upload/image/${filename}`);
    return response.data;
  },
};
